import React from 'react';
import ScopedNumbersTab from './ScopedNumbersTab';
import { ESCALATION_CONFIG } from '../constants';

const EscalationTab: React.FC = () => <ScopedNumbersTab config={ESCALATION_CONFIG} />;

export default EscalationTab;
